import React from 'react'
import { useDrop } from 'react-dnd'
import { connect } from 'react-redux'
import { styled, useTheme } from '@mui/material/styles'
import { Box, Paper } from '@mui/material'
import ItemTypes from '../../lib/item_types'
import { classNamesK } from '../../lib/util'
import { movingIndex, movePlayerTeam } from '../../lib/move'
import { initialScore } from '../../redux/reducers/score'
import TeamName from './TeamName'
import Players from './Players'
import Score from './score/Score'
import './Team.scss'

const TeamBox = styled(Box)(
  ({ theme }) => `
  &.hover {
    background-color: ${theme.palette.lightBack.primary};
  }

  &.multi-team, .team-info {
    border-color: ${theme.palette.team.border};
  }
`
)

const Team = ({ team, teamIndex, score: { sg }, rule }) => {
  const theme = useTheme()

  const [hover, setHover] = React.useState(false)

  const [, dropRef] = useDrop({
    accept: ItemTypes.PLAYER,
    collect: (monitor, _props) => {
      const item = monitor.getItem()
      if (!item) {
        setHover(false)
        return
      }
      const [dragTeamIndex] = movingIndex(item.player)
      if (dragTeamIndex === null || dragTeamIndex === teamIndex) {
        setHover(false)
        return
      }
      setHover(monitor.isOver())
    },
    drop: (item, _monitor) => {
      const [dragTeamIndex, dragPlayerIndex] = movingIndex(item.player)
      if (dragTeamIndex === null || dragTeamIndex === teamIndex) {
        return { moved: false }
      }
      movePlayerTeam(dragTeamIndex, dragPlayerIndex, teamIndex)
      return { moved: true }
    }
  })

  const teamScore = sg.team.scores.get(team.id) || initialScore
  const teamClass = classNamesK('team', {
    hover,
    multiTeam: rule.team.active
  })

  return (
    <TeamBox key={team.id} className={teamClass} ref={dropRef}>
      <Box className="team-info" hidden={!rule.team.active}>
        <TeamName team={team} teamIndex={teamIndex} />
        <Paper elevation={theme.palette.player.elevation}>
          <Score score={teamScore} />
        </Paper>
      </Box>
      <Players team={team} teamIndex={teamIndex} />
    </TeamBox>
  )
}

export default connect(
  state => ({
    score: state.score,
    rule: state.rule
  })
)(Team)
